import { Box, Divider, Grid, Paper, Skeleton } from "@mui/material";
import React from "react";

const TaskBoardLoader = () => {
  // Generate rows of skeleton loaders
  const rows = 15; // Number of rows in the table

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      {/* Header skeletons */}
      <Box sx={{ p: 2, display: "flex", gap: 2 }}>
        <Skeleton variant="rounded" width={40} height={24} />
        <Skeleton variant="rounded" width={160} height={24} />
        <Box sx={{ flexGrow: 1 }}></Box>
        <Skeleton variant="rounded" width={120} height={24} />
      </Box>

      <Divider />

      {/* Table header row */}
      <Grid container spacing={2} sx={{ p: 2, borderBottom: "1px solid rgba(224, 224, 224, 1)" }}>
        <Grid item xs={0.5}>
          <Skeleton variant="rounded" width="100%" height={10} />
        </Grid>
        <Grid item xs={2.5}>
          <Skeleton variant="rounded" width="80%" height={10} />
        </Grid>
        <Grid item xs={2}>
          <Skeleton variant="rounded" width="70%" height={10} />
        </Grid>
        <Grid item xs={1.5}>
          <Skeleton variant="rounded" width="60%" height={10} />
        </Grid>
        <Grid item xs={2}>
          <Skeleton variant="rounded" width="80%" height={10} />
        </Grid>
        <Grid item xs={2}>
          <Skeleton variant="rounded" width="70%" height={10} />
        </Grid>
        <Grid item xs={1}>
          <Skeleton variant="rounded" width="80%" height={10} />
        </Grid>
      </Grid>

      {/* Table rows */}
      {Array(rows)
        .fill(0)
        .map((_, index) => (
          <Grid
            container
            spacing={2}
            sx={{
              p: 2,
              borderBottom: "1px solid rgba(224, 224, 224, 0.4)",
              backgroundColor: index % 2 === 0 ? "rgba(0, 0, 0, 0.01)" : "transparent",
            }}
            key={index}
          >
            <Grid item xs={0.5}>
              <Skeleton variant="rounded" width="100%" height={10} />
            </Grid>
            <Grid item xs={2.5}>
              <Skeleton variant="rounded" width={`${Math.random() * 30 + 60}%`} height={10} />
            </Grid>
            <Grid item xs={2}>
              <Skeleton variant="rounded" width={`${Math.random() * 40 + 50}%`} height={10} />
            </Grid>
            <Grid item xs={1.5}>
              <Skeleton variant="rounded" width={`${Math.random() * 30 + 50}%`} height={10} />
            </Grid>
            <Grid item xs={2}>
              <Skeleton variant="rounded" width={`${Math.random() * 10 + 70}%`} height={10} />
            </Grid>
            <Grid item xs={2}>
              <Skeleton variant="rounded" width={`${Math.random() * 30 + 60}%`} height={10} />
            </Grid>
            <Grid item xs={1}>
              <Skeleton variant="rounded" width={`${Math.random() * 10 + 70}%`} height={10} />
            </Grid>
          </Grid>
        ))}
    </Paper>
  );
};

export default TaskBoardLoader;
